import React from 'react';
import { Avatar as ChakraAvatar } from '@chakra-ui/react';

interface AvatarProps {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  src?: string;
  name?: string;
  children?: React.ReactNode;
}

export function Avatar({ size = 'md', src, name, children }: AvatarProps) {
  return (
    <ChakraAvatar.Root size={size}>
      <ChakraAvatar.Fallback name={name} />
      <ChakraAvatar.Image src={src} alt={name} />
      {children}
    </ChakraAvatar.Root>
  );
}